export default {
    pageTitle: '2FA',
    intro: {
        p1: 'Two-factor authentication is required to log in to your Trendmanager account.',
        p2: 'We have sent an e-mail to "{email}".',
        p3: 'Use the code it contains to log in to Trendmanager.',
        p4: 'After successful authentication, re-authentication in this browser will be required again in 30 days.',
        p5: 'Your Trendone team'
    },
    form: {
        title: 'Enter second factor',
        action: 'Log in',
        secondFactor: {
            label: 'code',
            error: 'Please enter the code from the e-mail'
        },
        trustThisDevice: {
            label: 'Trust this device for 30 days?'
        }
    }
}
